import React, { FC, useEffect, useState } from "react";
import axios from "axios";
import moment from 'moment';
import { useTypedSelector } from "../reducers";
import { useNavigate } from "react-router-dom";
import { LoadPanel } from "devextreme-react/load-panel";
import { handleError } from "../error/ErrorHandler";

type Props = {
    menuId: number;
    brdId: number;
}

type BoardPostContentType = {
    brdContent: string;
    brdId: number;
    brdSeq: number;
    brdTitle: string;
    brdWriter: string;
    createdDtm: string;
    ctgId: number;
    hideYn: string;
    updatedDtm: string;
    usrNm: string;
}

const BoardPostContent: FC<Props> = ({menuId, brdId}) => {

    const [ post, setPost ] = useState<BoardPostContentType>();
    const { isLogin, loginUser, status, isAdmin } = useTypedSelector(state => state.auth);
    const [ loading, setLoading ] = useState(true);
    const navigate = useNavigate();

    const getPostContent = async() => {
        try {
            const res = await axios.get(`/api/board/post/one/${brdId}`);
            if (res.data) setPost(res.data);
        } catch(err) {
            handleError(err);
        } finally {
            setLoading(false);
        }
    };

    const deletePostContent = async() => {
        setLoading(true);
        let result = window.confirm("삭제하면 복구가 불가능합니다.\n삭제하시겠습니까?");
        if(result){
            try {
                const res = await axios.delete(`/api/board/post/${brdId}`)
                if (res.data) setPost(res.data);
                goToList();
            } catch(err) {
                handleError(err);
            } finally {
                setLoading(false);
            }
        } else setLoading(false);
    };

    const goToList = () => {
        navigate(`/board/${menuId}`);
    }

    const goToEdit = () => {
        navigate(`/board/${menuId}/edit/${brdId}`);
    }

    useEffect(() => {
        if (status === 'idle') return;
        getPostContent();
    }, [brdId, status]);

    return (
        <div className={'board-post-content-wrapper'}>
            { loading &&
                <LoadPanel visible={true} />
            }
            { !loading &&
                <div className={'board-post-content'}>
                    <div className={'board-post-content-item-wrapper'}>
                        <div className={'board-post-content-title-wrapper'}>
                            <div className={'board-post-content-title'}>
                                <span>{post?.brdTitle}</span>
                            </div>
                            <div className={'board-post-content-title-option-wrapper'}>
                                <div className={'board-post-content-date'}>
                                    <span>등록일 {moment(post?.createdDtm).format('YY.MM.DD')}</span>
                                </div>
                                <div className={'board-post-content-count'}>
                                </div>
                            </div>
                        </div>
                        <div className={'board-post-content-item'} dangerouslySetInnerHTML={{__html: String(post?.brdContent)}} />
                    </div>
                </div>
            }
            { !loading &&
                <div className={'board-post-content-button-wrapper'}>
                    <button className={'board-post-button-primary'} onClick={goToList}>목록</button>
                    {(isAdmin || (post?.brdWriter === loginUser?.usrId)) &&
                        <>
                            <button className={'board-post-button-light'} onClick={goToEdit}>수정</button>
                            <button className={'board-post-button-alert'} onClick={deletePostContent}>삭제</button>
                        </>
                    }
                </div>
            }
        </div>
    );
}

export default BoardPostContent;
